import { jsx as i, jsxs as n } from "react/jsx-runtime";
import d from "../FloorPlanIcon/FloorPlanIcon.js";
import h from "../SlideShowIcon/SlideShowIcon.js";
import f from "../VirtualTourIcon/VirtualTourIcon.js";
import a from "@material-ui/core/Box";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardActionArea";
import "@material-ui/core/CardActions";
import "@material-ui/core/CardContent";
import "@material-ui/core/CardMedia";
import "@material-ui/core/Checkbox";
import "@material-ui/core/Chip";
import "@material-ui/core/Container";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/ExpansionPanel";
import "@material-ui/core/ExpansionPanelDetails";
import "@material-ui/core/ExpansionPanelSummary";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/InputLabel";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemText";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Paper";
import "@material-ui/core/ScopedCssBaseline";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import u from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import g from "@material-ui/core/useMediaQuery";
import "@material-ui/core/withWidth";
import "@material-ui/icons/Bathtub";
import "@material-ui/icons/CalendarToday";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Close";
import "@material-ui/icons/ExpandMore";
import "@material-ui/icons/Hotel";
import "@material-ui/icons/KeyboardArrowDown";
import "@material-ui/icons/Pets";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Search";
import "@material-ui/lab/Alert";
import "@propify-tenant-client/common";
import { Fragment as x } from "react";
const b = u({
  container: {
    background: "rgba(0, 0, 0, .7)",
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    gap: 16,
    borderRadius: 4
  },
  item: {
    fontSize: 15,
    fontWeight: 700,
    color: "white",
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
    flex: 1,
    textAlign: "center",
    justifyContent: "center",
    whiteSpace: "nowrap"
  },
  divider: {
    height: 18,
    width: 1,
    background: "white"
  }
}), Io = ({
  virtualTourUrl: m,
  onViewFloorPlan: p,
  onViewPhotos: l,
  hideFloorPlan: s = !1
}) => {
  const t = g("@media (max-width:655px)"), r = b(), e = [
    {
      id: "photos",
      label: t ? "Photos" : "View Photos",
      icon: /* @__PURE__ */ i(h, {}),
      onClick: l
    },
    {
      id: "tour",
      label: "Virtual Tour",
      icon: /* @__PURE__ */ i(f, {}),
      onClick: () => window.open(m, "_blank"),
      hide: !m,
      iconStyle: {
        position: "relative",
        top: -1
      }
    },
    {
      id: "floorplan",
      label: t ? "Floorplan" : "View Floorplan",
      icon: /* @__PURE__ */ i(d, {}),
      onClick: p,
      hide: s || !p
    }
  ].filter((o) => !o.hide);
  return /* @__PURE__ */ i(a, { className: r.container, children: e.map((o, c) => /* @__PURE__ */ n(x, { children: [
    /* @__PURE__ */ n(a, { className: r.item, onClick: o.onClick, children: [
      !t && o.icon,
      o.label
    ] }),
    c < e.length - 1 && /* @__PURE__ */ i("div", { className: r.divider })
  ] }, o.id)) });
};
export {
  Io as default
};
//# sourceMappingURL=MediaButtons.js.map
